import { unwrapResult } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { getCurrentUser, storeMe } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';

export const Global = (Component: any) => {
  const WithGlobal = (props: any) => {
    const dispatch = useAppDispatch();

    const [me, setMe] = useState<any>(undefined);

    const fetchCurrentUser = async () => {
      try {
        const res: any = await unwrapResult(await dispatch(getCurrentUser()));
        setMe(res);
        dispatch(storeMe(res));
      } catch (e) {
        setMe(null);
      }
    };

    useEffect(() => {
      fetchCurrentUser();
    }, []);

    return <Component props={{ ...props, me }} />;
  };

  return WithGlobal;
};
